import { render } from "./CatalogItem.vue?vue&type=template&id=7e59112a"
import script from "./CatalogItem.vue?vue&type=script&lang=js"
export * from "./CatalogItem.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\schmidch\\IdeaProjects\\soilmap\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__